const LocationObject = {
    getUrlWithoutBranch() {
        return window.location.pathname.replace(/\/pobocka-[a-z-]+/, '')
    },

    isCart() {
        return this.getUrlWithoutBranch().startsWith('/kosik/krok')
    },
}

// hack.. Kvůli tomu, aby interface Location zůstala sám sebou
export { LocationObject as Location }
